import * as request from '@/utils/request'
const BASE_URL = '/v1/hr/recharge'

export default {
	/**
	 * @description 查看列表
	 * @author daihua
	 * @date 2022/2/22
	 * @param {*} data
	 * @returns
	 */
	//获取公司列表
	postRechargeList(data) {
		return request.post(`${BASE_URL}/companyAccountList`, data)
	},
	//设置充值条件
	postSettingRecharge(data) {
		return request.post(`${BASE_URL}/moneyCreate`, data)
	},
	//充值记录列表
	postRecordRechargeList(data) {
		return request.post(`${BASE_URL}/rechargeList`, data)
	},
	//套餐充值记录列表
	postRecordSet_mealRechargeList(data) {
		return request.post(`${BASE_URL}/setMealRechargeList`, data)
	},
	//套餐列表
	postSet_mealTagList(data) {
		return request.post(`${BASE_URL}/getSetMealList`, data)
	},
	//创建套餐
	postCreateSetMeal(data) {
		return request.post(`${BASE_URL}/createSetMeal`, data)
	},
	//删除套餐
	postdelSetMealID(data){
		return request.post(`${BASE_URL}/delSetMeal`, data)
	},
	//套餐充值
	postRechargeSetMeal(data) {
		return request.post(`${BASE_URL}/storeSetMeal`, data)
	},
	//查询单次费用
	postOneRechargeRecord(data) {
		return request.post(`${BASE_URL}/statisticsMoneyView`, data)
	},
	//手动扣费
	postManualDeduction(data) {
		return request.post(`${BASE_URL}/manualDeduction`, data)
	},
	//添加充值金额
	postAddRechargeRecord(data) {
		return request.post(`${BASE_URL}/store`, data)
	},
	getOss(data) {
		return request.get(`/v1/oss/sign`, data)

	}
}
